@if (authService.hasSecurityLevel("summary_view_new_ui_enabled")) {
    <div>Temporary unavailable</div>
} @else {
    <wk-all-view />
}
